import React from 'react';
import { AtSignIcon, MailIcon } from 'lucide-react';
import { Container } from './Container';

/** Reemplazá los href por las URLs reales de cada página legal, soporte y redes. */
const links = [{
  label: 'Términos y condiciones',
  href: '#terminos'
}, {
  label: 'Política de privacidad',
  href: '#privacidad'
}, {
  label: 'Política de reembolso',
  href: '#politica-reembolso'
}, {
  label: 'Contacto / soporte',
  href: 'mailto:soporte.viandasexpress15@gmail.com'
}];
const contact = [{
  icon: MailIcon,
  label: 'soporte.viandasexpress15@gmail.com',
  href: 'mailto:soporte.viandasexpress15@gmail.com'
}, {
  icon: AtSignIcon,
  label: '@viandas_express15',
  href: 'https://www.instagram.com/viandas_express15/'
}];
export function Footer() {
  return <footer className="bg-navy pb-28 pt-12 text-white md:pb-10" data-id="element-185" data-mp="3qfjhaeexf9n2">
      <Container data-id="element-186" data-mp="29ydwy1ied6af">
        <div className="grid gap-8 border-b border-white/10 pb-8 md:grid-cols-[1.2fr_1fr] md:items-start" data-id="element-187" data-mp="29xvrqfdrbhqd">
          <div data-id="element-188" data-mp="2ew6yuico3e4w">
            <p className="flex items-center gap-2" data-id="element-189" data-mp="3l9k4zam1djc8">
              <img src="https://cdn.magicpatterns.com/uploads/aKo3qjHS5aFjQUFTQWQvDL/Logo-kawaii-de-viandas-express.webp" alt="" width={56} height={56} loading="lazy" decoding="async" className="h-14 w-14 shrink-0 object-contain" data-id="element-190" data-mp="3labrlvxno6qd" />
              <span className="font-heading text-lg font-extrabold" data-id="element-191" data-mp="82qtvx6261vu">Viandas Express 15’</span>
            </p>
            <p className="mt-3 max-w-md text-base text-white/85" data-id="element-192" data-mp="34gxxkciex96">
              Porque organizar las viandas no debería costarte todas las noches.
            </p>
            <ul className="mt-4 flex flex-wrap gap-x-5 gap-y-2 text-sm font-medium text-teal-light" data-id="element-193" data-mp="huwlv6wb8jb1">
              {contact.map(({
              icon: Icon,
              label,
              href
            }) => <li key={label} data-id="element-194" data-mp="qub9zzp08hsd">
                  <a href={href} {...href.startsWith('http') ? {
                target: '_blank',
                rel: 'noopener noreferrer'
              } : {}} className="inline-flex items-center gap-1.5 underline-offset-4 hover:underline" data-id="element-195" data-mp="qr5i6cozr1sy">
                    <Icon aria-hidden="true" className="h-4 w-4" data-id="element-196" data-mp="yuh8chgjy14y" />
                    {label}
                  </a>
                </li>)}
            </ul>
          </div>
          <nav aria-label="Enlaces legales" data-id="element-197" data-mp="18ksn6z1rxuqm">
            <ul className="grid gap-2 text-sm font-medium text-teal-light md:justify-items-end" data-id="element-198" data-mp="1clmd1xys1jm5">
              {links.map(l => <li key={l.label} data-id="element-199" data-mp="1hjw4pylam230">
                  <a href={l.href} className="underline-offset-4 hover:underline" data-id="element-200" data-mp="1hiulh6u4i9a7">
                    {l.label}
                  </a>
                </li>)}
            </ul>
          </nav>
        </div>
        <p className="mt-6 max-w-3xl text-sm leading-relaxed text-white/75" data-id="element-201" data-mp="1rgirwu13d587">
          30 Días de Viandas Resueltas es un material educativo y organizativo de carácter general y no reemplaza asesoramiento médico o nutricional profesional.
        </p>
        <p className="mt-3 text-sm text-white/75" data-id="element-202" data-mp="2ag5eqppkvag4">© 2026 Viandas Express 15’ — Todos los derechos reservados.</p>
      </Container>
    </footer>;
}